import {Grid, Box, Typography } from "@mui/material";
  import ImageSlideshow from "../../components/ImageSlideShow";
  import { ZoomInRounded } from "@mui/icons-material";
  import TransitionsModal from "../../components/modal/modal";
  import ImageSlider from "../../components/ImageSlider";
  import { useState } from "react";
import ContentLayout from "../../components/ContentLayout";

import neuro_dept_img1 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-1.jpg";
import neuro_dept_img2 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-2.jpg";
import neuro_dept_img3 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-3.jpg";
import neuro_dept_img4 from "../../assets/images/facilities/infrastructure/departments/neuro_Dept/neuro-img-4.jpg";
  
  type ImageType = {
    src: string;
    alt: string;
  };
  
  type DepartmentObject = {
    name: string;
    img: Array<ImageType>;
  };
  
  const DepartmentData: Array<DepartmentObject> = [
    {
      name: "Department of Neuro Physiotherapy",
      img: [
        { src: neuro_dept_img1, alt: "neuro_dept_img1" },
        { src: neuro_dept_img2, alt: "neuro_dept_img2" },
        { src: neuro_dept_img3, alt: "neuro_dept_img3" },
        { src: neuro_dept_img4, alt: "neuro_dept_img4" },
      ],
    }
  ];
  
  const NeuroPhysiotherapy = () => {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState("");
    const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

    return (
      <>
        <ContentLayout>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                <Box sx={{ position: "relative" }} >
                    <ImageSlideshow
                    sx={{}}
                    images={DepartmentData[0]?.img as Array<ImageType>}
                    showCaption={false} showCount={false} />
                    <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    }}
                    onClick={() => {
                        setTitle(DepartmentData[0]?.name);
                        setSliderImages(DepartmentData[0]?.img);
                        setOpen(true);
                    } }
                    >
                    <ZoomInRounded
                        sx={{
                        color: "#fdd025",
                        zIndex: 99,
                        fontSize: "4rem",
                        "&:hover": {
                            fontSize: "6rem",
                        },
                        }} />
                    </Box>
                </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Neuro-Physiotherapy department at PES Modern College of Physiotherapy is dedicated to nurturing skilled professionals who can make a significant impact on the lives of individuals with neurological conditions.
                    The program provides a comprehensive understanding of the nervous system and its intricate relationship with movement, sensation, and function.
                    You will delve into the assessment and treatment of conditions such as stroke, spinal cord injury, multiple sclerosis, Parkinson's disease, and traumatic brain injury.
                    Our curriculum emphasizes evidence-based practice, clinical reasoning, and patient-centered care.
                    Through a combination of theoretical knowledge and extensive hands-on experience, you will develop the expertise to optimize motor function, sensory perception, and cognitive abilities in patients.
                    Join us in this rewarding field as we strive to enhance the quality of life for individuals with neurological impairments.
                </Typography>
                </Grid>

                <Grid item xs={12}>
                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"} fontWeight={'bold'}>
                    Adult Neuro Physiotherapy
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    A neurologic physical therapist is a physical therapist who specializes in the evaluation and treatment of individuals with movement problems due to insult in central nervous system or injury of the peripheral nervous system.
                    Physical therapists can help improve to restore the mobility you need to move forward with your life.
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    What is Neurological physical therapy? Neurological physiotherapy (Neuro Rehab) is a discipline focused on working with individuals who have a neurological disorders.
                    These include: Amyotrophic lateral sclerosis, Stroke, Parkinson disability, Spinal cord injury.
                    A neurologic physical therapist specializes in the evaluation and treatment of individuals with movement or functional problems due to disease or injury to the nervous system.
                </Typography>

                <Typography variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Neurological physiotherapists are experts in analysing normal and abnormal movements.
                    Are able to treat and address a wide range of impairments.
                    (Impairments can include muscle weakness, sensory changes, loss of balance, loss of function and loss of independence etc).
                    Neuro rehabilitation treatment includes: Gait Re-training, Balance Re-training, Mobility Aids, Hydrotherapy, Fall Prevention Program, Vestibular Rehabilitation 
                </Typography>

                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"} fontWeight={'bold'}>
                    Pediatric Physiotherapy
                </Typography>

                <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
                    Pediatric physiotherapy can be used to assess and treat babies, infants and children who present with some form of impaired physical development or movement dysfunction.
                    Not all children who are assessed will require therapy.
                    Sometimes it is only necessary to reassure parents that their children's physical signs and within normal limits.
                    If there is a problem, active intervention will be implemented by giving parents and care givers a programme of positioning, handling, exercises and education.
                    The aim is to facilitate good, normal and well-co-ordinated movement using activities of daily living and play.
                    Conditions treated include: Torticollis (the head is held to one side), Delayed motor development, Cerebral palsy, Co-ordination problems, Hypertonia, CTEV, Congenital Dislocation of HIP, SMA, Spinal deforming 
                </Typography>

                

                </Grid>
            </Grid>
        </ContentLayout>

        {sliderImages && (
            <TransitionsModal
              open={open}
              setOpen={setOpen}
              title={title}
              children={<Grid item xs={12} margin={"auto"}>
                <Box sx={{ width: "75%", margin: "auto" }}>
                  <ImageSlider images={sliderImages} />
                </Box>
              </Grid>} />
        )}
      </>
    );
  };
  
  export default NeuroPhysiotherapy;
